import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useIntl } from 'react-intl';
import { TextField } from '@mui/material';

import ButtonWithLoader from '../../../../../components/other/Buttons/ButtonWithLoader';
import { IProductType } from '../../../../../interfaces/productType';
import homeStyles from '../../../../../constants/homeStyles';
import { RedOutlinedButton } from '../../../../../components/other/Buttons';
import { useStylesTypeForm } from '../../hooks/useStyles';

interface IProps {
  type?: IProductType;
  typeAction: any;
  delProductType: any;
  editLoading: boolean;
}

const getInitialValues = (type?: IProductType) => ({
  name: type?.name || '',
  specialType: type?.special_type || 'physical',
});
const TypeTitleForm: React.FC<IProps> = ({
  type,
  typeAction,
  delProductType,
  editLoading,
}) => {
  const intl = useIntl();
  const classes1 = useStylesTypeForm();
  const { classes } = classes1;
  const homeClasses = homeStyles();
  return (
    <Formik
      initialValues={getInitialValues(type)}
      enableReinitialize
      validationSchema={Yup.object().shape({
        name: Yup.string()
          .required(intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' }))
          .nullable(),
      })}
      onSubmit={(values, { setSubmitting }) => {
        typeAction({
          name: values.name,
          specialType: 'physical',
        });
        setSubmitting(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleSubmit,
        handleChange,
        isSubmitting,
      }) => (
        <div>
          <form noValidate autoComplete='off' className='kt-form' onSubmit={handleSubmit}>
            <div className={classes.containerName}>
              <TextField
                type='text'
                label={intl.formatMessage({
                  id: 'PRODUCT.TYPES.INPUT.NAME',
                })}
                margin='normal'
                name='name'
                value={values.name}
                variant='outlined'
                onBlur={handleBlur}
                onChange={handleChange}
                helperText={touched.name && errors.name}
                error={Boolean(touched.name && errors.name)}
              />
              {/* </div> */}
            </div>

            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div className={homeClasses.classes.buttonContainer}>
                <ButtonWithLoader
                  loading={isSubmitting || editLoading}
                  disabled={editLoading}
                  onPress={handleSubmit}
                >
                  {intl.formatMessage({ id: 'PRODUCT.TYPES.BUTTON.SAVE' })}
                </ButtonWithLoader>
              </div>
              <div className={homeClasses.classes.buttonContainer} style={{ marginLeft: 10 }}>
                {type && (
                  <RedOutlinedButton onClick={delProductType}>
                    {intl.formatMessage({ id: 'PRODUCT.TYPES.BUTTON.DEL' })}
                  </RedOutlinedButton>
                )}
              </div>
            </div>
          </form>
        </div>
      )}
    </Formik>
  );
};

export default React.memo(TypeTitleForm);
